import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["input", "chip", "group", "column", "clear"]

  connect() {
    this._timeout = null
  }

  disconnect() {
    if (this._timeout) clearTimeout(this._timeout)
  }

  filter() {
    if (this._timeout) clearTimeout(this._timeout)
    this._timeout = setTimeout(() => this._doFilter(), 120)
  }

  clear() {
    this.inputTarget.value = ""
    this._doFilter()
    this.inputTarget.focus()
  }

  // private

  _doFilter() {
    const query = this.inputTarget.value.trim().toLowerCase()

    // Toggle clear button
    if (this.hasClearTarget) {
      this.clearTarget.classList.toggle("hidden", query.length === 0)
    }

    // Filter chips
    this.chipTargets.forEach(chip => {
      const name = (chip.dataset.searchName || "").toLowerCase()
      const match = query.length === 0 || name.includes(query)
      chip.classList.toggle("hidden", !match)
    })

    // Hide empty groups
    this.groupTargets.forEach(group => {
      const visibleChips = group.querySelectorAll(
        '[data-workspace-search-target="chip"]:not(.hidden)'
      )
      group.classList.toggle("hidden", visibleChips.length === 0)
    })

    // Hide empty columns
    this.columnTargets.forEach(col => {
      const visibleChips = col.querySelectorAll(
        '[data-workspace-search-target="chip"]:not(.hidden)'
      )
      col.classList.toggle("hidden", visibleChips.length === 0)
    })
  }
}
